import { Injectable } from '@angular/core';
import { map, Observable, take } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { IPersonData } from '../../interface/api/order-ttt.interface';
import { IUserInfoOIDC } from '../../interface/login.interface';

type LocalOidcClaims = Partial<IUserInfoOIDC> & {
  given_name?: string;
  family_name?: string;
  phone_number?: string;
};

export function mapLocalOidcUser(claims: LocalOidcClaims | null): IPersonData {
  const subject = claims?.sub?.trim();
  if (!subject) {
    throw new Error('OIDC user data does not contain sub');
  }

  return {
    id: subject,
    oidc: subject,
    email: claims?.email ?? '',
    phone: claims?.phone ?? claims?.phone_number ?? '',
    name: claims?.first_name ?? claims?.given_name ?? '',
    surname: claims?.last_name ?? claims?.family_name ?? '',
    second_name: claims?.middle_name ?? '',
  };
}

@Injectable({
  providedIn: 'root',
})
export class UserIdentityService {
  constructor(private oidc: OidcSecurityService) {}

  getInfo(): Observable<IPersonData> {
    return this.oidc.getUserData().pipe(
      take(1),
      map((claims) => mapLocalOidcUser(claims as LocalOidcClaims | null)),
    );
  }
}
